export const AUDIT_ROWS = [
  {
    "eyebrow": "Why it fails",
    "question": "Why can a tag be installed and still not fire?",
    "intro": "A tag added once is not a tag that works today. Three causes have nothing to do with whether the code is on the page.",
    "rows": [
      {
        "heading": "Consent banners",
        "body": "If a visitor hasn’t accepted cookies, many setups hold ad and analytics tags. Our scan doesn’t click accept, so you see exactly what an unconsented visitor sends."
      },
      {
        "heading": "Server-side tagging",
        "body": "Events go to your own endpoint and on to Google or Meta, so the browser shows almost nothing. A fully measured site can look quiet."
      },
      {
        "heading": "Trigger conditions",
        "body": "A tag in Google Tag Manager fires only when its trigger matches. A deleted thank-you page or a renamed button, and the event never records."
      }
    ],
    "after": "That is why every result has an “unknown” state. We report what one real browser load could see, so you know where to look next."
  },
  {
    "eyebrow": "Check it yourself",
    "question": "How do I check my conversion tracking myself?",
    "intro": "",
    "rows": [
      {
        "heading": "Read “Last conversion” in Google Ads",
        "body": "Open Goals, then Conversions. A blank “Last conversion” column means nothing has been recorded recently: the fastest sign something is wrong."
      },
      {
        "heading": "Run Tag Assistant",
        "body": "Open your site in Chrome with Tag Assistant. It lists every Google tag that fires and flags errors and missing conversions."
      },
      {
        "heading": "Watch the Network tab",
        "body": "Reload the page and filter for “collect” (GA4) or “/tr” (Meta). Nothing there on a page that should fire means nothing was sent."
      }
    ],
    "after": "All three healthy? Your tracking is probably in decent shape. Any of them empty? Compare the tag setup against your real pages and buttons."
  },
  {
    "eyebrow": "If nothing fires",
    "question": "What should I do if nothing is firing?",
    "intro": "",
    "rows": [
      {
        "heading": "Open Tag Manager Preview",
        "body": "Visit your site in Preview mode and watch whether each tag triggers. A trigger pointing at the wrong page, form or button is the usual cause."
      },
      {
        "heading": "Check the consent setup",
        "body": "Blocking ad and analytics tags until opt-in is a valid choice. It should be a deliberate one, not an accident."
      },
      {
        "heading": "Confirm the IDs",
        "body": "For hard-coded tags, check the container and pixel IDs. Old agency IDs, deleted containers and staging configs survive on live sites for months."
      },
      {
        "heading": "Look for a server container",
        "body": "If one exists, the browser looks quiet even when everything works. Trace the server endpoint, not the page."
      }
    ],
    "after": "Still unsure? Scan a specific page URL and compare. One load is a snapshot; two or three pages start to tell a story."
  }
];
export const AUDIT_FAQS = [
  {
    "question": "What does this audit look for?",
    "answer": "Whether the Google Ads conversion tag, GA4, Google Tag Manager and the Meta pixel are installed and actually firing, and whether a form submission or a call is recorded as a conversion. A tag can be on the page without working."
  },
  {
    "question": "What is a conversion tracking audit?",
    "answer": "A conversion tracking audit checks whether the tags that report leads and sales back to your ad platforms are actually firing. It covers the Google Ads conversion tag, GA4, Google Tag Manager and the Meta pixel, and it distinguishes between a tag that is absent and one that cannot be seen from the browser."
  },
  {
    "question": "How much does a conversion tracking audit cost?",
    "answer": "The automated scan on this page is free and requires no email. A manual audit, where we open the ad accounts alongside the site and trace each conversion action, is quoted per account."
  },
  {
    "question": "Do you offer conversion tracking audit services?",
    "answer": "Yes. The scanner above is free and checks what fires on the page. For a full audit of your Google Ads and Meta accounts, including what is counted as a conversion and what is being double counted, book a review on the contact page."
  },
  {
    "question": "Is there a free tool to check if Google Ads conversion tracking is working?",
    "answer": "Yes. This page checks one public page in a real browser, free and with no email required, and shows which Google Ads, GA4 and Meta tags loaded, which didn't, and which it couldn't verify. A server-side or consent-gated setup can be invisible to the scan and still be working, so treat \"couldn't verify\" as unknown, not broken."
  }
];
export const AUDIT_TAGS = [
  {
    "heading": "Google Ads conversion tag",
    "body": "Tells Google Ads a visitor became a lead. Without it, campaigns optimize for clicks, not jobs, and you can’t tell which keyword produced the work."
  },
  {
    "heading": "GA4",
    "body": "Records what happens on the site: page views, events, sources. Not a conversion tag, but it shows whether traffic turns into action."
  },
  {
    "heading": "Google Tag Manager",
    "body": "The container many tags ship in. Present doesn’t mean the right tags are inside. Absent usually means hard-coded tags."
  },
  {
    "heading": "Meta pixel",
    "body": "Reports leads and builds audiences for Facebook and Instagram. Without it, Meta can’t tie a lead back to the ad."
  }
];
export const AUDIT_SCHEMA_QUESTIONS = [...AUDIT_FAQS.slice(0, 1), ...AUDIT_ROWS.map(s => ({ question: s.question, answer: [s.intro, ...s.rows.flatMap(r => [r.heading, r.body]), s.after].filter(Boolean).join(" ") })), ...AUDIT_FAQS.slice(1)];

export const AUDIT_CENSUS = { percentage: 27.4, advertisers: 1807, sample: 9560, dots: 100, hollow: 27 };
